import React from 'react';
import { BrainIcon, CheckIcon, FlameIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, BOX_IMAGE_ALT, offerChecklist } from '../data/content';
export function OfferSection() {
  return <section id="offer" className="w-full bg-slate-950 px-5 pb-14 pt-4" data-id="element-120" data-mp="8m3xzt5shi01">
      <div className="mx-auto flex max-w-[1000px] flex-col items-center" data-id="element-121" data-mp="df6sc3ie4vha">
        <p className="rounded-md bg-orange-500 px-4 py-1.5 text-[0.8rem] font-black uppercase tracking-[0.2em] text-slate-950" data-id="element-122" data-mp="idrjldfo04tl">
          Special launch offer
        </p>

        <div className="mt-4 w-full overflow-hidden rounded-xl border-2 border-dashed border-orange-500/70 bg-slate-900" data-id="element-123" data-mp="mgo8tmzpmz6i">
          <div className="border-b border-orange-500/30 bg-slate-800 px-5 py-5 text-center sm:py-6" data-id="element-124" data-mp="wcraysukaxtg">
            <h2 className="flex items-center justify-center gap-2.5 text-[clamp(1.6rem,5vw,2.6rem)] font-black uppercase leading-none tracking-tight text-white" data-id="element-125" data-mp="2t5t1quz7c91h">
              <BrainIcon className="h-[0.9em] w-[0.9em] shrink-0 text-orange-500" aria-hidden="true" data-id="element-126" data-mp="2y6grldbp2ju4" />
              ANATOMY READY™
            </h2>
            <p className="mt-2 text-balance text-[clamp(0.8rem,2vw,1rem)] font-extrabold uppercase leading-tight tracking-tight text-orange-500" data-id="element-127" data-mp="xup6wt0ecvfa">
              The complete visual teaching system for A&P teachers
            </p>
          </div>

          <div className="grid items-center gap-6 p-5 sm:p-8 md:grid-cols-2 md:gap-10" data-id="element-128" data-mp="1lmw9i9wptyn5">
            <img src={BOX_IMAGE} alt={BOX_IMAGE_ALT} className="mx-auto w-full max-w-[460px] md:max-w-[400px]" width={1240} height={1240} data-id="element-129" data-mp="1gnjeh1voxl9h" />

            <div data-id="element-130" data-mp="17ljtxzlgvz1s">
              <h3 className="text-[1.5rem] font-black uppercase leading-none tracking-tight text-white sm:text-[1.6rem]" data-id="element-131" data-mp="17m3d1jmusthe">
                Complete 6-in-1 System
              </h3>

              <ul className="mt-4 space-y-3" data-id="element-132" data-mp="3sbspxr3zy57g">
                {offerChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[1.05rem] text-white" data-id="element-133" data-mp="3tv14cgqsn77i">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-green-500" aria-hidden="true" data-id="element-134" data-mp="2lc5lpo2elf2">
                      <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={4} data-id="element-135" data-mp="3b3i1qb0olv60" />
                    </span>
                    {item}
                  </li>)}
              </ul>

              <div className="mt-6 rounded-lg border-2 border-orange-500 bg-slate-950 px-4 py-4 text-center" data-id="element-136" data-mp="31759ziop5rdw">
                <p className="flex items-center justify-center gap-2 text-[1rem] font-black uppercase leading-tight tracking-tight text-white" data-id="element-137" data-mp="362c8mc3405vy">
                  <FlameIcon className="h-5 w-5 shrink-0 fill-orange-500 text-orange-500" aria-hidden="true" data-id="element-138" data-mp="2x48p1lbopj6s" />
                  Get ANATOMY READY™ today —
                </p>
                <p className="mt-1 text-[3rem] font-black leading-none tracking-tight text-orange-500 sm:text-[3.2rem]" data-id="element-139" data-mp="28kezh8kguqeb">
                  $27 USD
                </p>
              </div>

              <CtaButton label="Get instant access" className="mt-4 w-full py-4 sm:py-5" data-id="element-140" data-mp="2ig8kzhg5xu88" />

              <p className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-[0.8rem] font-bold uppercase tracking-wide text-white/85" data-id="element-141" data-mp="2wegd9c2987d2">
                <span data-id="element-142" data-mp="3662x1wsnrerf">Immediate digital access</span>
                <span aria-hidden="true" className="text-orange-500" data-id="element-143" data-mp="317rorqi0hcbb">
                  |
                </span>
                <span className="flex items-center gap-1.5" data-id="element-144" data-mp="3f6r8qkukx315">
                  <ShieldCheckIcon className="h-4 w-4 shrink-0 text-orange-500" aria-hidden="true" data-id="element-145" data-mp="3f4y3n9zm6qv9" />
                  7-day money-back guarantee
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}